import React, { useState, useEffect } from 'react';
import OrderCrudService from '../../services/OrderCrudService';
import { Tabs, Tab, Form, Row, Col, Card, Button, Modal, Alert, Table } from 'react-bootstrap';

export default function ModalClient({ show, handleClose, dataItem, setRenderRows }) {

	const [validated, setValidated] = useState(false);
	const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
	const styles = { cardContainer: { maxHeight: '45vh', overflowY: 'auto', marginBottom: '20px' } };

	const [orderStatus, setOrderStatus] = useState(null);
	const [orderName, setOrderName] = useState(null);
	const [orderUsername, setOrderUsername] = useState(null);
	const [orderStoreCode, setOderStoreCode] = useState(null);
	const [orderTotal, setOrderTotal] = useState(null);
	const [orderPayMethod, setOrderPayMethod] = useState();
	const [paymentTransactionId, setPaymentTransactionId] = useState();
	const [orderProducts, setOrderProducts] = useState([]);
	const [orderT1response, setOrderT1response] = useState('');
	const [successSend, setSuccessend] = useState(null);
	const [orderClient, setOrderClient] = useState('');

	useEffect(() => {
		if (show && dataItem.codeItem > 0) {

			OrderCrudService.getOrderById(dataItem.codeItem, dataItem.storeCode).then(async res => {

				let currentOrder = res.data.data[0];

				setOrderStatus(currentOrder.status);
				setOrderName(currentOrder.customer.name);
				setOrderUsername(currentOrder.customer.username);
				setOderStoreCode(currentOrder.storeCode);
				setPaymentTransactionId(currentOrder.paymentTransactionId);
				setOrderTotal(currentOrder.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
				setOrderPayMethod(currentOrder.payMethod);
				setOrderProducts(currentOrder.invoice);
				setOrderClient(currentOrder.client_id.name);
				setOrderT1response(JSON.parse(currentOrder.t1Response));

			});
		} else {

			setPaymentTransactionId(null);
			setOrderStatus(null);
			setOrderName(null);
			setOrderUsername(null);
			setOderStoreCode(null);
			setOrderTotal(null);
			setOrderPayMethod(null);
			setOrderProducts([]);
			setOrderT1response('');
			setSuccessend(null);
			setOrderClient('');

		}
	}, [dataItem, show]);

	function sleep(time) {
		return new Promise((resolve) => setTimeout(resolve, time)
		)
	}

	const reSendOrder = async (event) => {
		let updateOrder = { storeCode: orderStoreCode, code: dataItem.codeItem };
		OrderCrudService.resendOrder(updateOrder).then(res => {

			setSuccessend('success');
			sleep(2000).then(() => {
				handleClose();
				window.location.href = '/orders'
			})

		}).catch(err => {
			console.log(err);
			if (err.response.status !== 200) {
				setSuccessend('danger');
			}
		});
	};

	const handleSubmit = async (event) => {
		const form = event.currentTarget;
		if (form.checkValidity() === false) {
			event.preventDefault();
			event.stopPropagation();
		} else {
			let updateUser = '';// to do{ name: userName, username: userUserName, providerType: providerType, path: userPath, suscriptionId: suscriptionId };
			if (!dataItem.codeItem && dataItem.typeView === 'Create') {
				console.log('toDo: create');
			} else {
				console.log('toDo: update');
			}
		}
		setValidated(true);
	};

	let addSubmitButton = "";
	if (!conditionView) {
		addSubmitButton = <Button type="submit">Save Changes</Button>;
	}

	const setCloseButton = <><Button variant="secondary" onClick={handleClose}> Close </Button> {'  '}  {'  '} </>;
	let tabT1response = "";

	tabT1response = (
		<Tab eventKey="t1response" title="T1 Response">
			<pre>
				{JSON.stringify(orderT1response, null, 2)}
			</pre>

			{setCloseButton}
			<Button type="button" onClick={reSendOrder}>ReSend Order</Button>

			{(successSend == 'danger') ?
				(<Alert key='danger' variant='danger'> ¡La orden no pudo ser reenviada! Intenta mas tarde. </Alert>)
				: (successSend == 'success') ?
					(<Alert key='success' variant='success'> ¡La orden Se re-envio con exito! </Alert>) : ""
			}
		</Tab>
	);

	return (
		<>
			<Modal size="lg" show={show} onHide={handleClose} backdrop="static"
				aria-labelledby="contained-modal-title-vcenter"
				dialogClassName="custom-modal-dialog"
			>
				<Modal.Header closeButton>
					<Modal.Title> {dataItem.typeView} {dataItem.nameView} {dataItem.codeItem} {orderClient ? ` Client: ${orderClient}` : ''}</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<Tabs
						defaultActiveKey="main"
						id="justify-tab-example"
						className="mb-2"
						justify
					>
						<Tab eventKey="main" title="Data Order">
							<Form noValidate validated={validated} onSubmit={handleSubmit}>
								<Row className="mb-2">

									<Form.Group as={Col} md="4" controlId="validCustom1">
										<Form.Label>Status</Form.Label>
										<Form.Control
											required
											type="text"
											placeholder="Status"
											defaultValue={orderStatus}
											disabled
											readOnly={true}
										/>
									</Form.Group>

									<Form.Group as={Col} md="4" controlId="validCustom2">
										<Form.Label>Name</Form.Label>
										<Form.Control
											required
											type="text"
											placeholder="Name"
											defaultValue={orderName}
											disabled
											readOnly={true}
										/>
									</Form.Group>

									<Form.Group as={Col} md="4" controlId="validCustom3">
										<Form.Label>UserName</Form.Label>
										<Form.Control
											required
											type="text"
											placeholder="UserName"
											defaultValue={orderUsername}
											disabled
											readOnly={true}
										/>
									</Form.Group>
								</Row>
								<Row className="mb-2">

									<Form.Group as={Col} md="4" controlId="validCustom4">
										<Form.Label>StoreCode</Form.Label>
										<Form.Control
											required
											type="text"
											placeholder="StoreCode"
											defaultValue={orderStoreCode}
											disabled
											readOnly={true}
										/>
									</Form.Group>

									<Form.Group as={Col} md="4" controlId="validCustom5">
										<Form.Label>Order Total</Form.Label>
										<Form.Control
											required
											type="text"
											placeholder="OrderTotal"
											defaultValue={orderTotal}
											disabled
											readOnly={true}
										/>
									</Form.Group>

									<Form.Group as={Col} md="4" controlId="validCustom6">
										<Form.Label>Order PayMethod</Form.Label>
										<Form.Control
											required
											type="text"
											placeholder="Order PayMethod"
											defaultValue={orderPayMethod}
											disabled
											readOnly={true}
										/>
									</Form.Group>
								</Row>

								<Row className="mb-2">
									<Form.Group as={Col} md="8" controlId="validCustom7">
										<Form.Label>Transaction Id</Form.Label>
										<Form.Control
											required
											type="text"
											placeholder="TransactionId"
											defaultValue={paymentTransactionId}
											disabled
											readOnly={true}
										/>
									</Form.Group>
								</Row>

								<hr></hr>

								<Card className='card' border='primary' style={styles.cardContainer}>
									<Card.Header><b>Products : ( {orderProducts.length} )</b></Card.Header>
									<Card.Body>
										<Table size="sm" striped bordered hover style={{ width: '99%', borderColor: 'lightgreen' }}>
											<thead>
												<tr>
													<th>Name</th>
													<th>Qty</th>
													<th>Price</th>
												</tr>
											</thead>
											<tbody>
												{orderProducts ? orderProducts.map((itemProduct, indexItem) => {
													return (
														<tr key={indexItem}>
															<td> {itemProduct.name} </td>
															<td> {itemProduct.qty} </td>
															<td> {'$ ' + itemProduct.uPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} </td>
														</tr>
													);
												}) : null}
											</tbody>
										</Table>
									</Card.Body>
								</Card>

							</Form>
							{setCloseButton}
						</Tab>
						{tabT1response}
					</Tabs>
				</Modal.Body>
			</Modal>
		</>
	);
}